
class ServiceRequestLabors {
    static restructureLaborList(labors) {
          const list =  labors.map(i => {
              return {
                  serviceRequestLaborId : i.serviceRequestLaborId,
                  serviceRequestId : i.serviceRequestId,
                  vendorId : i.vendorId,
                  laborCost : i.laborCost,
                  discount : i.discount,
                  quantity : i.quantity,
                  description : i.description,
                  isLaborEditable : false
                }
          });
        return list;
    }
}

export default ServiceRequestLabors;